import { SortDirection } from '@tanstack/react-table';
import { cva } from 'class-variance-authority';

export const header = cva(['border-b', 'border-grayscale100'], {
  variants: {
    sticky: {
      true: ['sticky', 'top-0'],
      false: [],
    },
  },
});

export const headerCell = cva([
  'py-12',
  'px-24',
  'text-left',
  'bg-grayscale50',
]);

export const cell = cva([
  'flex',
  'items-center',
  'p-24',
  'text-left',
  'overflow-hidden',
]);

export const row = cva([
  'border-b',
  'last:border-b-0',
  'border-b-grayscale100',
]);

export const sortIndicator = cva<{
  order: Record<SortDirection | 'false', Array<string>>;
}>(['text-grayscale500'], {
  variants: {
    order: {
      asc: ['rotate-180'],
      desc: [''],
      false: ['opacity-0'],
    },
  },
});
